import { InvalidUrlError } from '../../../common/errors/errors';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { FeatureFlagsType, getFeatureFlag } from '../../../config/launch-darkly/FeatureFlagsController';
import { IssueMapper } from '../mappers/IssueMapper';
import { Issue } from '../models/Issue';

export const GET_ISSUES_QUERY = `
query ($reportId: ID!, $includeFilteredRules: Boolean, $includeInstances: Boolean!, $keptByFilters: Boolean) {
  node(id: $reportId) {
    ... on ReportDone {
      id
      rules(includeDisabledRules: true, includeFilteredRules: $includeFilteredRules) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
            filterStatus
            instances (keptByFilters: $keptByFilters, filters: {field: severity, operation: NEQ, value: "PASSED"}) @include(if: $includeInstances) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export class ReportIssuesRepository extends BaseGQLService {
  private readonly issueMapper = new IssueMapper();

  async getIssues(reportId: number, includeFilteredRules: boolean): Promise<Issue[]> {
    return this.query(
      GET_ISSUES_QUERY,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        includeFilteredRules,
        includeInstances: Boolean(getFeatureFlag(FeatureFlagsType.ENABLE_JIRA_BATCH_EXPORT)),
        keptByFilters: includeFilteredRules ? null : true,
      },
      (data) => {
        if (!data.node) {
          throw new InvalidUrlError(`Invalid request: could not find Report ${reportId}`);
        }
        return data.node.rules.edges.map((e: any) => this.issueMapper.mapGQLModel({ ...e.node, reportId: data.node.id }));
      }
    );
  }
}
